
import {
pageRechargeRecords,
pageConsumeRecords
} from "@/api/shoppingGold.js";
import {
getCookie
} from "@/utils/auth.js";
import Api from '@/api.js';
import Alert from 'vux/src/components/alert/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'



export default {
data() {
return {
selectMenu:"Recharge",//选择充值记录  或者  消费记录  默认充值
totalAmount:0,//可用金额
rechargeAmount:0,//充值金额
bounsAmount:0,//赠送金额
rechargeList:[],//充值记录
consumeList:[],//消费记录
shwoLoading:true,//显示加载中
}
},
directives: {
TransferDom
},
components: {
Alert,
Confirm,
Toast,
Loading
},
created() {

},
mounted: function() {
if(this.$route.query.selectMenu){
this.selectMenu = this.$route.query.selectMenu;

if(this.selectMenu == 'Recharge'){
this.getPageRechargeRecordsFun();
}else if(this.selectMenu == 'Consume'){

this.getPageConsumeRecordsFun();
}
}
},
methods: {

getPageRechargeRecordsFun(){
let params = {
pageNum:1,
pageSize:200
}
let that = this;
pageRechargeRecords(params).then(res => {
that.shwoLoading = false;
console.log("返回--------", res)
if (res.code == 1) {
that.totalAmount = res.data.totalAmount;
that.rechargeAmount = res.data.rechargeAmount;
that.bounsAmount = res.data.bounsAmount;
that.rechargeList = res.data.rechargePageInfo.list;
}

})
},


getPageConsumeRecordsFun(){
let params = {
pageNum:1,
pageSize:200
}
let that = this;
pageConsumeRecords(params).then(res => {
console.log("返回--------", res)
that.shwoLoading = false;
if (res.code == 1) {
that.totalAmount = res.data.totalAmount;
that.rechargeAmount = res.data.rechargeAmount;
that.bounsAmount = res.data.bounsAmount;
that.consumeList = res.data.consumeRecordPageInfo.list;
}
console.log("that.consumeList--------", that.consumeList)

})
},



checkMenuFun(type){
this.selectMenu = type;
this.shwoLoading = true;

if(type == 'Recharge'){
this.getPageRechargeRecordsFun();
}else if(type == 'Consume'){

this.getPageConsumeRecordsFun();
}
},


detailFun(info){
this.$router.push({
path: '/shoppingGoldInfo',
query: {
id: info.id,
}
})
}
},
filters: {

dateFormat: function(dataStr) {
var time = new Date(dataStr);

function timeAdd0(str) {
if (str < 10) {
str = '0' + str;
}
return str
}
var y = time.getFullYear();
var m = time.getMonth() + 1;
var d = time.getDate();
var h = time.getHours();
var mm = time.getMinutes();
var s = time.getSeconds();
return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + " " + "" + timeAdd0(h) + ":" + timeAdd0(mm) + ":" + timeAdd0(s);
},

strToFixed: function(num1, num2) {
let total = num1 * num2;
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
if (len > 0) {
return total.toFixed(2)
} else {
return total
}
} else {
return total
}
},

strAddToFixed: function(total) {
console.log("total---------", total)
if (total.toString().indexOf('.') > -1) {
let arr = total.toString().split('.');
let len = arr[1].length;
if (len > 0) {
return total.toFixed(2)
} else {
return total
}
} else {
return total
}
},


getYuan:function (value) {
var value = Math.round(parseFloat(value) * 100) / 10000;
var xsd = value.toString().split(".");
if (xsd.length == 1) {

return value;
}
if (xsd.length > 1) {
if (xsd[1].length < 2) {
value = value.toString() + "0";
}
return value;
}
},

getRefundStatus:function(refundStatus){
var message = "";
switch (refundStatus) {
case 1:
message = "(部分提现)";
break;
case 2:
message = "(全部提现)";
break;
}
return message;
},

getRefundRefundStatus:function(refundStatus){
var message = "";
switch (refundStatus) {
case 1:
message = "(部分返还)";
break;
case 2:
message = "(全部返还)";
break;
}
return message;
}
}
}



// WEBPACK FOOTER //
// ./src/view/shoppingGold/shoppingGoldList.vue